/**
 *
 * @param event The keyboard event to handle.
 */
export function handleKeyboardTrigger(event: KeyboardEvent, clickHandler: () => void) {
  if (event.key === 'Enter' || event.key === ' ') {
    // Prevent the default action of Spacebar on some elements (like scrolling)
    event.preventDefault();
    window.$app.logger.log('Spacebar or Enter key pressed. Prevent default action and call click handler.');
    clickHandler(); // Call your "click" handler
  }
}
